export default {
  blackLists: [],

  saleManagerDiscountLimits: [],

  saleManagerCredits: [],

  ordrSettings: [],

  orders: [],
  orderById: {},
  orderMaxCode: null,

  orderCartable: [],

  orderManagementCartable: [],

  settlementTypes: [],

  printLink: {},
};
